import { render, staticRenderFns } from "./gateway-wage-setting.vue?vue&type=template&id=8a447956"
import script from "./gateway-wage-setting.vue?vue&type=script&lang=js"
export * from "./gateway-wage-setting.vue?vue&type=script&lang=js"
import style0 from "./gateway-wage-setting.vue?vue&type=style&index=0&id=8a447956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports